/**
 * AbilityAttack.js
 * Implements a regular attack as part of an ability
 */

import { Game } from "pixi_core";

import { Ability } from "./Ability";
import { Common } from "../Common";
import { EnemyParticle } from "../particles/EnemyParticle";

import {
    GameEvents,
    ENEMY_ATTACK_PARTICLE_TARGET_X,
    ENEMY_ATTACK_PARTICLE_TARGET_X_CAPTAIN_AMERICA,
    ENEMY_ATTACK_PARTICLE_TARGET_Y,
    ENEMY_ATTACK_PARTICLE_TARGET_Y_RANGE
} from "../../Constants";

export class AbilityAttack extends Ability {
    /**
     * @public
     * @param {Number} attackDamage
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(attackDamage, startPos, callback) {
        super();

        /** @private @type {Number} */
        this._attackDamage = attackDamage;

        /** @private @type {Function} */
        this._callback = callback;

        // Attack particle targetting the heroes hp bar
        let targetX = ENEMY_ATTACK_PARTICLE_TARGET_X;
        let targetY =
            ENEMY_ATTACK_PARTICLE_TARGET_Y -
            ENEMY_ATTACK_PARTICLE_TARGET_Y_RANGE +
            ENEMY_ATTACK_PARTICLE_TARGET_Y_RANGE * Math.random() * 2;

        if (Common.heroes.isCaptainAmericaShieldActive()) {
            targetX = ENEMY_ATTACK_PARTICLE_TARGET_X_CAPTAIN_AMERICA;
        }

        Common.particles.createEnemyAttackParticle(startPos.x, startPos.y, targetX, targetY, this._onAttackParticleCompleted.bind(this));
    }

    /**
     * @private
     * @param {EnemyParticle} particle
     */
    _onAttackParticleCompleted(particle) {
        Game.fire(GameEvents.eHEROES_HIT, this._attackDamage, particle);

        if (this._callback) {
            this._callback();
        }
    }

    /**
     * @public
     */
    destroy() {
        this._callback = null;
    }
}
